import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EPrivileges } from "../../../shared/oversight-core/enums/privileges";
import { UserRole } from "../../../shared/oversight-core/enums/user-roles";
import { RootState } from "../../store";

type AuthState = {
  token: string | null;
  isNewUser: boolean;
  email: string;
  privileges: EPrivileges[];
  userRole: UserRole;
};

const token = localStorage.getItem("token");
const privileges: EPrivileges[] = JSON.parse(
  localStorage.getItem("privileges") || JSON.stringify([])
) as EPrivileges[];
const userRole: UserRole = privileges.includes(
  EPrivileges.ROLE_SOLAR_DASHBOARD_ADMIN
)
  ? UserRole.ROLE_SOLAR_DASHBOARD_ADMIN
  : UserRole.ROLE_USER;

const initialState: AuthState = {
  token: null,
  isNewUser: false,
  email: "",
  privileges: [],
  userRole: userRole,
};

export const authSlice = createSlice({
  name: "auth",
  initialState: { ...initialState, token, privileges },
  reducers: {
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload;
    },
    setPrivileges: (state, action: PayloadAction<EPrivileges[]>) => {
      state.privileges = action.payload;
    },
    setUserRole: (state, action: PayloadAction<UserRole>) => {
      state.userRole = action.payload;
    },
    setIsNewUser: (
      state,
      action: PayloadAction<
        Omit<AuthState, "token" | "privileges" | "userRole">
      >
    ) => {
      state.isNewUser = action.payload.isNewUser;
      state.email = action.payload.email;
    },
  },
});

export const { setToken, setIsNewUser, setPrivileges, setUserRole } =
  authSlice.actions;

export const selectAuth = (state: RootState) => state.auth;

export default authSlice.reducer;
